import { createContext } from "react";
import { iEnquiry } from "../interfaces/iEnquiry";
export const ChangeEnquiryOwnershipContext = createContext((enquiries: Array<iEnquiry>) => {});
